module.exports = __webpack_public_path__ + "static/media/square-fill.d606911e.svg";